var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.514 4.23a2.494 2.494 0 0 0-3.753 3.267l-.004-.007-.197.222-3.92 1.722-.537-.291a2.68 2.68 0 0 0-3.206.49 2.084 2.084 0 0 0 .013 2.913l3.295 3.34-5.517 5.517a.642.642 0 0 0 .909.909l5.516-5.517 3.29 3.27a2.146 2.146 0 0 0 2.96.06c.887-.81 1.102-2.121.52-3.172l-.335-.608 1.691-3.633.345-.414a2.494 2.494 0 0 0 3.185-3.813L17.515 4.23zm2.49 7.227c-.333 0-.635-.135-.855-.355a.875.875 0 0 0-1.29.058l-.05.06a7.951 7.951 0 0 0-1.103 1.737l-1.171 2.517a2 2 0 0 0 .056 1.801l.198.362a1.202 1.202 0 0 1-.24 1.457.973.973 0 0 1-1.348-.026l-7.29-7.29a.963.963 0 0 1-.02-1.341c.38-.402.98-.498 1.466-.236l.793.428a1 1 0 0 0 .877.036l3.497-1.536a4.034 4.034 0 0 0 1.393-1.014l.014-.016a.913.913 0 0 0-.037-1.253 1.209 1.209 0 1 1 1.71-1.71l4.255 4.255a1.206 1.206 0 0 1 0 1.711c-.218.22-.52.355-.854.355z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.a9b979e9.svg";
export { ForwardRef as ReactComponent };